import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {WatchService} from "../../services/watch.service";
import {CollectionService} from "../../services/collection.service";
import {Subject} from "rxjs/Subject";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'nv-game-events',
  templateUrl: './nv-game-events.component.html',
  styles: []
})
export class NvGameEventsComponent implements OnInit, OnDestroy {

  @Input() document:IDocument;
  @Input() propertyName:string;

  private unsubscribe: Subject<void> = new Subject<void>();
  loadedEventsList:any[]=[];
  currentEvent:any;

  constructor(private collectionService:CollectionService,
              private watchService:WatchService) { }

  ngOnInit() {
    this.loadEventsList();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private loadEventsList(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.GAME_EVENT).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedEventsList = r.documents;
        this.loadedEventsList.sort(this.sortByName);
        //console.log(this.loadedEventsList);
        if (this.loadedEventsList.length > 0)
        {
          this.loadedEventsList.unshift({codeName:"NOT SELECTED", id:-1});
          this.currentEvent = this.loadedEventsList[0];

        }
      });
  }

  onAddClick(){
    console.log(this.currentEvent);
    if (this.currentEvent.id >= 0)
    {
      if (this.document[this.propertyName] == null)
      {
        this.document[this.propertyName] = [];
      }
      this.document[this.propertyName].push(this.currentEvent.id);
      this.watchService.notify();
    }

  }

  getEventLabel(e){
    for (let evt of this.loadedEventsList)
    {
      if (evt.id == e)
      {
        return evt['codeName'];
      }
    }
    return 'NO NAME';
  }

  private sortByName(a, b):number
  {
    if (a.name > b.name)
    {
      return 1;
    }
    else if (a.name < b.name)
    {
      return -1;
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-game-events/nv-game-events.component.ts